import React, { memo, useMemo } from 'react'
import { IFullStop, STOP_TYPE } from 'types'
import { MarketplaceStopSection } from './MarketplaceStopSection'

interface IMarketplaceStopsProps {
  stops: IFullStop[]
}

const stopTypeLength = (stopType: STOP_TYPE, stops: IFullStop[]) =>
  stops.filter(stop => stop.type === stopType).length

const stopNumber = (stop: IFullStop, pickupLength: number, dropoffLength: number): number => {
  const isMultiPickup = stop.type === STOP_TYPE.pickup && pickupLength > 1
  const isMultiDropoff = stop.type === STOP_TYPE.delivery && dropoffLength > 1
  return isMultiPickup || isMultiDropoff ? stop.stopSequence : 0
}

const getStopNumbers = (stops: IFullStop[]) => {
  const pickupLength = stopTypeLength(STOP_TYPE.pickup, stops)
  const dropoffLength = stopTypeLength(STOP_TYPE.delivery, stops)
  return stops.map(stop => stopNumber(stop, pickupLength, dropoffLength))
}

export const MarketplaceStops = memo<IMarketplaceStopsProps>(({ stops = [] }) => {
  const stopNumbers = useMemo(() => getStopNumbers(stops), [stops])
  return (
    <>
      {stops.map((stop, idx) => {
        return <MarketplaceStopSection key={stop.id} stop={stop} sequence={stopNumbers[idx]} />
      })}
    </>
  )
})
